import { render, staticRenderFns } from "./MktSection.vue?vue&type=template&id=798f1307&"
import script from "./MktSection.vue?vue&type=script&lang=js&"
export * from "./MktSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports